(function () {
  'use strict';

  /**
   * ICP PDF Uploader
   *
   * Simple AI-powered PDF upload for ICP test analysis
   * Automatically extracts parameters and populates form
   */

  var API_URL = 'https://ema-chatbot-api-production.up.railway.app/api/engines/icp-pdf-analyzer';

  // ── Helper: Get element by ID ──
  function el(id) {
    return document.getElementById(id);
  }

  function setVal(id, v) {
    var e = el(id);
    if (e) {
      if (v !== undefined && v !== null) {
        console.log('[ICP-UPLOADER] setVal: ' + id + ' = ' + v + ' (was: ' + e.value + ')');
        e.value = v;
        console.log('[ICP-UPLOADER] setVal: confirmed value is now ' + e.value);
      }
    } else {
      console.warn('[ICP-UPLOADER] setVal: Element not found for ID: ' + id);
    }
  }

  // ── Show status message ──
  function showStatus(msg, type) {
    var statusEl = el('ema-icp-status');
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = 'ema-icp-status' + (type ? ' is-' + type : '');
    statusEl.style.display = 'block';
    if (type !== 'error') {
      setTimeout(function () { statusEl.style.display = 'none'; }, 5000);
    }
  }

  // ── Handle PDF upload ──
  var fileInput = el('ema-icp-pdf-file');
  if (fileInput) {
    fileInput.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;

      if (file.type !== 'application/pdf') {
        showStatus('❌ Please upload a PDF file', 'error');
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        showStatus('❌ PDF file is too large (max 10MB)', 'error');
        return;
      }

      // Upload and analyze
      uploadAndAnalyzePDF(file);
    });
  }

  function uploadAndAnalyzePDF(file) {
    var uploadBtn = el('ema-icp-upload-btn');
    var fileInput = el('ema-icp-pdf-file');

    // Show loading state
    if (uploadBtn) {
      uploadBtn.disabled = true;
      uploadBtn.textContent = '🔄 Analyzing PDF...';
    }
    showStatus('📄 Reading PDF and extracting parameters...', '');

    // Prepare form data
    var formData = new FormData();
    formData.append('pdf', file);

    // Send to API
    fetch(API_URL + '/analyze', {
      method: 'POST',
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[ICP-UPLOADER] API Response:', data);

        if (!data.success) {
          throw new Error(data.error || 'Unknown error');
        }

        console.log('[ICP-UPLOADER] Response successful, populating fields...');

        // ✅ Success! Populate the form
        populateParameterFields(data);
        showStatus('✅ ' + data.message, 'success');

        // Reset file input
        fileInput.value = '';

        // Update button
        if (uploadBtn) {
          uploadBtn.disabled = false;
          uploadBtn.textContent = '✅ Upload Another PDF';
        }
      })
      .catch(function (err) {
        showStatus('❌ ' + (err.message || 'Failed to analyze PDF'), 'error');
        if (uploadBtn) {
          uploadBtn.disabled = false;
          uploadBtn.textContent = '📤 Upload PDF';
        }
      });
  }

  function populateParameterFields(data) {
    console.log('[ICP-UPLOADER] populateParameterFields called');
    console.log('[ICP-UPLOADER] Data received:', data);

    // Map API parameter names to form field IDs
    // Only includes parameters that have corresponding form fields
    var paramMap = {
      calcium: 'ema-param-ca',
      magnesium: 'ema-param-mg',
      phosphate: 'ema-param-po4',
      nitrate: 'ema-param-no3'
      // Note: These parameters are in the ICP data but don't have form fields:
      // potassium, strontium, boron, iodine, iron, zinc, molybdenum,
      // manganese, nickel, cobalt, chromium, copper
    };

    console.log('[ICP-UPLOADER] Parameter map:', paramMap);
    console.log('[ICP-UPLOADER] Available parameters:', Object.keys(data.parameters || {}));

    // Fill in parameter fields that exist in the form
    for (var paramName in data.parameters) {
      var fieldId = paramMap[paramName];
      if (fieldId) {
        var value = data.parameters[paramName];
        var element = el(fieldId);
        console.log('[ICP-UPLOADER] Setting ' + paramName + ' to ' + value);
        console.log('[ICP-UPLOADER] Field element found:', !!element, 'ID:', fieldId);
        if (element) {
          console.log('[ICP-UPLOADER] Field value before:', element.value);
          setVal(fieldId, value);
          console.log('[ICP-UPLOADER] Field value after:', element.value);
        }
      }
    }

    // Set ICP brand and type if form has those fields
    if (data.brand) {
      var brandSelect = el('ema-icp-brand-select');
      if (brandSelect) {
        // Try to match brand
        if (data.brand.toLowerCase().includes('fauna')) {
          brandSelect.value = 'Fauna Marin';
        } else if (data.brand.toLowerCase().includes('red sea')) {
          brandSelect.value = 'Red Sea';
        } else if (data.brand.toLowerCase().includes('brightwell')) {
          brandSelect.value = 'Brightwell Aquatics';
        } else {
          brandSelect.value = 'Other';
        }
      }

      // Set type if available
      var typeSelect = el('ema-icp-type-select');
      if (typeSelect && data.type) {
        typeSelect.value = data.type;
      }
    }

    // Set test date if available
    if (data.testDate) {
      setVal('ema-icp-test-date', data.testDate);
    }
  }

  // ── Initialize on page load ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initICP);
  } else {
    initICP();
  }

  function initICP() {
    // Create simple status element if it doesn't exist
    var statusEl = el('ema-icp-status');
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.id = 'ema-icp-status';
      statusEl.className = 'ema-icp-status';
      statusEl.style.display = 'none';
      statusEl.style.cssText = 'padding: 12px 16px; border-radius: 6px; margin-bottom: 16px; font-size: 0.9rem; text-align: center; display: none;';

      var uploadSection = el('ema-icp-pdf-upload');
      if (uploadSection) {
        uploadSection.insertBefore(statusEl, uploadSection.firstChild);
      }
    }

    // Make status element visible
    statusEl.style.display = 'none';
  }

})();
